import React, { useState } from "react";
import BRSRSidebar from "../../Layout/BRSRSidebar";
import ReviewPage from "../Common/ReviewPage";
import { useBRSR } from "../../context/BRSRContext";
import { useParams } from "react-router-dom";

const BrsrReview = () => {
  const { id } = useParams();
  const [disable, setDisable] = useState(false);

  return (
    <ReviewPage
      component={<BRSRSidebar onDisableChange={setDisable} />}
      module={"BRSR"}
      url={`/brsr/section-a/${id}`}
      url1={"/brsr"}
      updateUrl={`/brsr/updateBRSR/${id}`}
      disable={disable}
    />
  );
};

export default BrsrReview;
